/**
 * Table columns configuration for VehicleInformationStep
 */
import React from 'react';

/**
 * Get table columns for vehicle details
 */
export const getTableColumns = ({
	handleDocumentPreview,
	handleViewVehicle,
	RC_DOCUMENT_LABEL,
	INSURANCE_DOCUMENT_LABEL,
	DocumentPreviewIcon,
	PendingDocumentStatus,
	ViewButton,
	EyeOutlined,
	FileTextOutlined,
	ExclamationCircleOutlined,
}) => {
	const renderPendingBadge = () => (
		<PendingDocumentStatus>
			<ExclamationCircleOutlined style={{ fontSize: 14 }} />
			<span>Pending</span>
		</PendingDocumentStatus>
	);

	return [
		{
			title: 'Vehicle Type',
			key: 'vehicleType',
			render: (_, record) => record.vehicleType || record.vehicle_type || '-',
		},
		{
			title: 'Vehicle Number',
			key: 'vehicleNumber',
			render: (_, record) => record.vehicleNumber || record.vehicle_number || '-',
		},
		{
			title: RC_DOCUMENT_LABEL,
			key: 'rcDocument',
			render: (_, record) => {
				const fileKey = record.rc_document_key;
				const hasDoc = record.rcDocument || !!fileKey;
				if (!hasDoc) {
					const isPending =
						record.skip_document_upload || record.documents_complete === false;
					return isPending ? renderPendingBadge() : '-';
				}

				const fileName = record.rc_document_file?.name || RC_DOCUMENT_LABEL;
				return (
					<DocumentPreviewIcon
						onClick={() => handleDocumentPreview(fileKey, fileName)}
						title={`Click to view ${RC_DOCUMENT_LABEL}`}
					>
						<FileTextOutlined />
					</DocumentPreviewIcon>
				);
			},
		},
		{
			title: 'Insurance',
			key: 'insurance',
			render: (_, record) => {
				const fileKey = record.insurance_document_key;
				const hasDoc = record.insurance || !!fileKey;
				if (!hasDoc) {
					const isPending =
						record.skip_document_upload || record.documents_complete === false;
					return isPending ? renderPendingBadge() : '-';
				}

				const fileName = record.insurance_document_file?.name || INSURANCE_DOCUMENT_LABEL;
				return (
					<DocumentPreviewIcon
						onClick={() => handleDocumentPreview(fileKey, fileName)}
						title={`Click to view ${INSURANCE_DOCUMENT_LABEL}`}
					>
						<FileTextOutlined />
					</DocumentPreviewIcon>
				);
			},
		},
		{
			title: 'Ownership Type',
			key: 'ownershipType',
			render: (_, record) => record.ownershipType || record.ownership_type || '-',
		},
		{
			title: 'Actions',
			key: 'actions',
			render: (_, record) => (
				<ViewButton
					icon={<EyeOutlined style={{ fontSize: '18px' }} />}
					onClick={() => handleViewVehicle(record)}
				/>
			),
		},
	];
};
